import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { aiChatFeature } from './lib/state/ai-chat.reducer';
import { AiChatEffects } from './lib/state/ai-chat.effects';

export * from './lib/ai-chat/ai-chat.component';
export * from './lib/ai-chat.config';
export * from './lib/state/ai-chat.actions';
export * from './lib/state/ai-chat.reducer';
export * from './lib/state/ai-chat.effects';
export * from './lib/chat-workflow-plan-card/chat-workflow-plan-card.component';
export * from './lib/v2';

/**
 * Pure function providing the localized NgRx State and Effects for the AI Chat module.
 * Intended to be imported into the route providers where the AI Chat is loaded.
 */
export function provideAiChatFeature() {
  return [provideState(aiChatFeature), provideEffects([AiChatEffects])];
}
